import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { communicationApi, type Notification } from '../../api/communication';

export function NotificationCenterPage() {
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const [error, setError] = useState('');
  const [unreadOnly, setUnreadOnly] = useState(false);

  const load = () => {
    void communicationApi.listNotifications(undefined, unreadOnly)
      .then((r) => setNotifications(r.notifications))
      .catch((e) => setError(String(e)));
  };

  useEffect(() => { load(); }, [unreadOnly]);

  const markRead = async (id: string) => {
    await communicationApi.markRead(id);
    load();
  };

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/communication" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Communication Hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Notification Center</h1>
      <label className="mt-4 flex items-center gap-2 text-sm">
        <input type="checkbox" checked={unreadOnly} onChange={(e) => setUnreadOnly(e.target.checked)} />
        Unread only
      </label>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <ul className="mt-6 space-y-3">
        {notifications.length === 0 && (
          <li className="text-sm text-slate-500">No notifications</li>
        )}
        {notifications.map((n) => (
          <li key={n.id} className={`rounded-lg border p-4 dark:border-slate-700 ${n.read ? 'opacity-60' : ''}`}>
            <div className="flex justify-between">
              <span className="font-medium">{n.title}</span>
              {!n.read && (
                <button onClick={() => void markRead(n.id)} className="text-xs text-blue-600 hover:underline">
                  Mark read
                </button>
              )}
            </div>
            {n.body && <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">{n.body}</p>}
            <p className="mt-1 text-xs text-slate-500">{n.category} · {new Date(n.created_at).toLocaleString()}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}
